/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases.bulkUpload', {
      url: '/bulkUpload',
      template: '<bulk-upload></bulk-upload>',
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/bulkUpload/bulkUpload.routes.js